export class PointsDetails {
	ProgramId: number;
	ProgramName: string;
	Points: number;
	Delta: number;
	TotalAcquiredPoints: number;
}
